const CirculoError = ({ size }) => {
  return (
    <svg
      width={size ? size : "37"}
      height={size ? size : "37"}
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18.5" cy="18.5" r="17" stroke="#C10C00" strokeWidth="3" />
      <path
        d="M12.0461 25.0817L24.9531 12.0469"
        stroke="#C10C00"
        strokeWidth="3"
      />
      <path
        d="M24.9539 25.0817L12.0469 12.0469"
        stroke="#C10C00"
        strokeWidth="3"
      />
    </svg>
  );
};

export default CirculoError;
